// extracted by mini-css-extract-plugin
export default {"Container":"style_Container__tOVkA","Card":"style_Card__zfhmE","Icon":"style_Icon__eHA7w","Cell":"style_Cell__Trapl"};